module.exports = __webpack_public_path__ + "img/icon-key-79952e2c.svg";